export const GET_ALLOYOFFSETS_STATED = 'GET_ALLOYOFFSETS_STATED';
export const GET_ALLOYOFFSETS = 'GET_ALLOYOFFSETS';
export const GET_ALLOYOFFSETS_ENDED = 'GET_ALLOYOFFSETS_ENDED';

export const ADD_ALLOYOFFSET_STATED = 'ADD_ALLOYOFFSET_STATED';
export const ADD_ALLOYOFFSET = 'ADD_ALLOYOFFSET';
export const ADD_ALLOYOFFSET_ENDED = 'ADD_ALLOYOFFSET_ENDED';

export const EDIT_ALLOYOFFSET_STATED = 'EDIT_ALLOYOFFSET_STATED';
export const EDIT_ALLOYOFFSET = 'EDIT_ALLOYOFFSET';
export const EDIT_ALLOYOFFSET_ENDED = 'EDIT_ALLOYOFFSET_ENDED';

export const GET_ALLOYOFFSET_STATED = 'GET_ALLOYOFFSET_STATED';
export const GET_ALLOYOFFSET = 'GET_ALLOYOFFSET';
export const GET_ALLOYOFFSET_ENDED = 'GET_ALLOYOFFSET_ENDED';

export const GET_ALL_ALLOYOFFSETS_STATED = 'GET_ALL_ALLOYOFFSETS_STATED';
export const GET_ALL_ALLOYOFFSETS = 'GET_ALL_ALLOYOFFSETS';
export const GET_ALL_ALLOYOFFSETS_ENDED = 'GET_ALL_ALLOYOFFSETS_ENDED';
